<section class="tdb-block" data-testid="testdaten-block">
  <header class="tdb-header">
    <svg class="tdb-header-icon" viewBox="0 0 24 24" width="13" height="13" aria-hidden="true">
      <path d="M3 5h18v4H3zM3 11h18v4H3zM3 17h18v4H3z" fill="currentColor" />
    </svg>
    <span class="tdb-title">{{ titleKey() | translate }}</span>
  </header>

  @for (row of rendered(); track row.tdb.id) {
    <div class="tdb-row" [attr.data-testid]="'tdb-row-' + row.tdb.id">
      <div class="tdb-row-head">
        <code class="tdb-id">{{ row.tdb.id }}</code>
        <span class="tdb-name">{{ row.tdb.name }}</span>
        @if (row.constrained) {
          <span class="tdb-status tdb-status--restricted">{{ 'tdb.status.restricted' | translate }}</span>
          <span class="tdb-status tdb-status--count" [attr.data-testid]="'tdb-rows-label-' + row.tdb.id">
            {{ row.rowsLabel }}
          </span>
          <button
            type="button"
            class="tdb-reset"
            [attr.data-testid]="'tdb-reset-' + row.tdb.id"
            [disabled]="disabled()"
            (click)="onReset(row.tdb.id)"
          >
            {{ 'tdb.reset' | translate }}
          </button>
        } @else {
          <span class="tdb-status tdb-status--all" [attr.data-testid]="'tdb-rows-label-' + row.tdb.id">
            {{ row.rowsLabel }}
          </span>
        }
        @if (unlinkable()) {
          <button
            type="button"
            class="tdb-unlink"
            [attr.data-testid]="'tdb-unlink-' + row.tdb.id"
            [attr.aria-label]="'tdb.unlink' | translate: { key: row.tdb.id }"
            (click)="onUnlink(row.tdb.id)"
          >
            <svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true">
              <path
                d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                fill="currentColor"
              />
            </svg>
          </button>
        }
      </div>

      <div class="tdb-field">
        <div class="tdb-field-label">{{ 'tdb.field.rowSelection' | translate }}</div>
        <input
          type="text"
          class="tdb-input tdb-input--mono"
          [class.tdb-input--active]="row.filterActive"
          [attr.data-testid]="'tdb-filter-input-' + row.tdb.id"
          [attr.aria-label]="'tdb.filter.ariaLabel' | translate: { id: row.tdb.id }"
          [disabled]="disabled()"
          [value]="row.filter"
          [placeholder]="'tdb.filter.placeholder' | translate"
          [attr.aria-invalid]="row.unreadable ? 'true' : null"
          [attr.aria-describedby]="row.hasHint ? 'tdb-filter-warning-' + instanceId + '-' + row.tdb.id : null"
          (input)="onFilterInput(row.tdb.id, $event)"
        />
        @if (row.hasHint) {
          <div
            class="tdb-hints"
            [id]="'tdb-filter-warning-' + instanceId + '-' + row.tdb.id"
            [attr.data-testid]="'tdb-filter-warning-' + row.tdb.id"
          >
            @if (row.unreadable) {
              <p class="tdb-warning">{{ 'tdb.filter.warning' | translate: { clauses: row.unreadable } }}</p>
            }
            @if (row.missingRows) {
              <p class="tdb-warning">
                {{
                  (row.missingRowCount > 1 ? 'tdb.filter.missingRows' : 'tdb.filter.missingRow')
                    | translate: { rows: row.missingRows, total: row.tdb.rows }
                }}
              </p>
            }
            @if (row.onlyInactive) {
              <p class="tdb-warning">{{ 'tdb.filter.onlyInactive' | translate }}</p>
            }
          </div>
        }
      </div>

      @if (showCondition()) {
        <div class="tdb-field">
          <div class="tdb-field-label">{{ 'tdb.field.condition' | translate }}</div>
          <app-step-condition-editor
            [override]="row.override"
            [scopeId]="row.tdb.id"
            [disabled]="disabled()"
            (changed)="onConditionChange(row.tdb.id, $event)"
          />
        </div>
      }

      @if (showPreview()) {
        <code
          class="tdb-preview"
          [attr.data-testid]="'tdb-code-preview-' + row.tdb.id"
          [attr.aria-label]="'tdb.preview.ariaLabel' | translate: { id: row.tdb.id }"
        >
          {{ row.preview }}
        </code>
      }
    </div>
  }

  <p class="tdb-footnote" [innerHTML]="'tdb.footnote' | translate"></p>
</section>
